import { Link, usePage, router } from '@inertiajs/react';
import type { SharedProps } from '@/types';

interface NavbarProps {
  currentSection?: 'home' | 'accounting' | 'food' | 'settings';
}

export function Navbar({ currentSection }: NavbarProps) {
  const { currentUser } = usePage<SharedProps>().props;

  function handleLogout() {
    router.delete('/users/sign_out');
  }

  if (!currentUser) {
    return null;
  }

  return (
    <nav className="bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-14">
          {/* Left side - Logo and main nav */}
          <div className="flex items-center gap-8">
            <Link href="/" className="flex items-center gap-2">
              <svg
                width="24"
                height="24"
                className="text-blue-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                />
              </svg>
              <span className="font-semibold text-gray-900">Family App</span>
            </Link>

            <div className="flex items-center gap-1">
              <Link
                href="/"
                className={`px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                  currentSection === 'home'
                    ? 'text-blue-600 bg-blue-50'
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                }`}
              >
                Home
              </Link>
              <Link
                href="/accounting"
                className={`px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                  currentSection === 'accounting'
                    ? 'text-blue-600 bg-blue-50'
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                }`}
              >
                Accounting
              </Link>
              <Link
                href="/food"
                className={`px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                  currentSection === 'food'
                    ? 'text-blue-600 bg-blue-50'
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                }`}
              >
                Food
              </Link>
              <Link
                href="/settings"
                className={`px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                  currentSection === 'settings'
                    ? 'text-blue-600 bg-blue-50'
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                }`}
              >
                Settings
              </Link>
            </div>
          </div>

          {/* Right side - User info and logout */}
          <div className="flex items-center gap-4">
            <span className="text-sm text-gray-500">{currentUser.email}</span>
            <button
              onClick={handleLogout}
              className="px-3 py-1.5 text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-md transition-colors"
            >
              Sign Out
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
